import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

import { BaseLink } from "~/components/common/base-link";
import { setFullViewportWidthStyles } from "~/lib/styles";

import FooterBackgroundImage from "./footer-background.svg?url";
import FooterPeterAndPippaImage from "./footer-peter-and-pippa.svg";
import HomepageIcon from "./homepage-icon.svg?url";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  position: relative;
`;

export const ArticleMoreStoriesContainer = styled.div`
  max-inline-size: 441px;
  margin-inline: auto;
  padding-inline: 20px;

  overflow: hidden;
  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 788px;
    padding-inline: 0;
  }
  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    max-inline-size: 1140px;
  }
`;

export const StyledFooterImageContainer = styled.div`
  position: relative;

  background-image: url(${FooterBackgroundImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  aspect-ratio: 375/188;

  ${props => props.theme.breakpoints.up("tablet")} {
    aspect-ratio: 700/188;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    aspect-ratio: 1024/392;
  }
  ${props => props.theme.breakpoints.up("largeDesktop")} {
    aspect-ratio: 1440/392;
  }
`;

export const StyledPeterAndPippaImageContainer = styled.div`
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 50%;

  block-size: 74.5%;

  transform: translate(-50%, -50%);
  aspect-ratio: 349/140;

  ${props => props.theme.breakpoints.up("desktop")} {
    aspect-ratio: 772/308;

    block-size: 78.7%;
  }
`;
export const StyledPeterAndPippaImage = styled(FooterPeterAndPippaImage)`
  inline-size: 100%;
  block-size: 100%;
`;

export const ButtonLink = styled(BaseLink)`
  position: relative;
  z-index: 1;

  display: table;

  margin-block-end: 42px;
  margin-inline: auto;
  padding-block: 13px 11px;
  padding-inline: 33px 37px;

  &::before,
  &::after {
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 0;
    content: "";

    inline-size: 100%;
    block-size: 100%;

    border-radius: 100px;
  }

  &::before {
    border: 2px solid #000000;
  }

  &::after {
    inset-block-start: 5px;
    inset-inline-start: -5px;
    z-index: -1;

    background: #fecc17;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 86px;
  }
`;

export const ButtonText = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 600;
  font-size: 18px;
  font-family: ${fontFredoka};
  line-height: 18px;
  text-align: center;
  &::before {
    content: "";

    inline-size: 24px;
    block-size: 24px;
    margin-inline-end: 19px;

    background-image: url(${HomepageIcon});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
`;
